import { useMemo } from 'react'

import { useProductRefreshAppShell } from 'features/app_shell/product_refresh/useProductRefreshAppShell'
import { SCHEDULING_ROUTING_FORMS_TAB_BASE } from 'hooks/home/tabs'
import { LEGACY_ROUTING_FORMS_BASE } from 'shared/constants/routing_forms_paths'

/** List URL base for policy redirects and “back to forms” when embedded list lives under Scheduling (refresh). */
export const useRoutingFormsBase = () => {
  const isProductRefreshAppShell = useProductRefreshAppShell()
  return useMemo(
    () => (isProductRefreshAppShell ? SCHEDULING_ROUTING_FORMS_TAB_BASE : LEGACY_ROUTING_FORMS_BASE),
    [isProductRefreshAppShell]
  )
}

export const newFormUrl = (step) => `${LEGACY_ROUTING_FORMS_BASE}/new/${step}`

export const editFormUrl = (id, step) => `${LEGACY_ROUTING_FORMS_BASE}/${id}/edit/${step}`

export const formResponsesUrl = (id) => `${LEGACY_ROUTING_FORMS_BASE}/${id}/responses`
